import React from 'react';
export function StickyBottomBar() {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 py-3 px-4 md:py-4" data-id="element-121">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-122">
        <div className="flex items-center gap-2 text-gray-900 font-bold text-sm md:text-base" data-id="element-123">
          <span data-id="element-124">Don't Risk Another Seizure — Prepare Safely</span>
        </div>
        <a href="https://shopglisera.com/products/glisera-anti-alcohol-patch" className="w-full sm:w-auto bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-3 px-8 rounded shadow-md transition-colors text-sm uppercase tracking-wide whitespace-nowrap" data-id="element-125">
          Get Glisera Now — 60-Day Guarantee
        </a>
      </div>
    </div>;
}